/* @flow */
import invariant from 'invariant';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import ModalMenuItem from 'components/ModalMenuItem.jsx';
import * as React from 'react';
import RequestTranscriptModal from 'organizations/components/RequestTranscriptModal.jsx';
import GroupMembership from 'entities/GroupMembership';

type Props = {
  isAdminView?: ?boolean,
  groupToAdmin: Group,
  groupMembership: GroupMembership,
  disabled?: boolean,
};

class GetTranscriptMenuItem extends React.Component<Props> {
  requestTranscriptModal = () => {
    const { groupMembership, groupToAdmin, isAdminView } = this.props;
    const org = groupToAdmin.getOrganization();
    invariant(org, 'missing org in GetTranscriptMenuItem');

    const users = [
      {
        id: groupMembership.getUserId(),
        fullName: groupMembership.getUser().getFullName(),
        firstName: groupMembership.getUser().getFirstName(),
        canGetMessageHistory: groupMembership.hasPermission('can_get_message_history'),
        canRequestMessageHistory: groupMembership.hasPermission('can_request_message_history'),
      },
    ];

    return (
      <RequestTranscriptModal
        users={users}
        organizationId={org.id}
        organizationName={org.getName()}
        forceRequestMessageHistory={!isAdminView}
      />
    );
  };

  render() {
    return (
      <ModalMenuItem
        modal={this.requestTranscriptModal()}
        disabled={this.props.disabled}
        {...this.props}>
        <Glyph name="email-transcript" />
        <span>{this.props.isAdminView ? 'Get message history' : 'Request message history'}</span>
      </ModalMenuItem>
    );
  }
}

export default GetTranscriptMenuItem;
